module.exports = __webpack_public_path__ + "img/NPC_NO_ONE.png";